export default __webpack_public_path__ + "logo-03cda0bc.png";